import { render, staticRenderFns } from "./VolunteerSummary.vue?vue&type=template&id=cb98eeba"
import script from "./VolunteerSummary.vue?vue&type=script&lang=ts"
export * from "./VolunteerSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports